import script from "./RangeSectionsTable.vue?vue&type=script&setup=true&lang=js"
export * from "./RangeSectionsTable.vue?vue&type=script&setup=true&lang=js"

import "./RangeSectionsTable.vue?vue&type=style&index=0&id=673f8980&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-673f8980"]])

export default __exports__